import { BADGE_COLORS } from '../../constants/status';

const StatusBadge = ({ status }) => {
  const color = BADGE_COLORS[status] || '#6b7280';

  return (
    <span
      style={{
        backgroundColor: `${color}15`, // slight transparency
        color: color,
        padding: '4px 12px',
        borderRadius: '0.3rem',
        fontSize: '13px',
        letterSpacing: '0.025em',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
      }}
    >
      {status}
    </span>
  );
};

export default StatusBadge;

export const StatusNewBadge = ({ status }) => {
  const badge = status || {
    text: 'Unknown',
    color: '#6b7280',
  };

  return (
    <span
      style={{
        backgroundColor: `${badge.color}15`,
        color: badge.color,
        padding: '4px 12px',
        borderRadius: '0.3rem',
        fontSize: '13px',
        letterSpacing: '0.025em',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
      }}
    >
      {badge.text}
    </span>
  );
};
